import React, { useState, lazy, Suspense } from "react";
import { useTranslation } from 'react-i18next';

// id에 해당하는 내용.jsx 불러오기
const Detail002Components = {
	1: lazy(() => import("./detail_002_01.jsx")),
	2: lazy(() => import("./detail_002_02.jsx")),
	3: lazy(() => import("./detail_002_03.jsx")),
	4: lazy(() => import("./detail_002_04.jsx")),
	5: lazy(() => import("./detail_002_05.jsx")),
	6: lazy(() => import("./detail_002_06.jsx")),
	7: lazy(() => import("./detail_002_07.jsx")),
	8: lazy(() => import("./detail_002_08.jsx")),
	9: lazy(() => import("./detail_002_09.jsx")),
};

// nav-pill 항목들
const Detail002 = ({ customerInfo }) => {
	const { t }                     = useTranslation();
	const [activeTab, setActiveTab] = useState(1);

	const navStyle = {
		background:'rgb(125, 163, 144)',
	};

	const navPills = [
		{ id: 1, label: t(`LOAN_RECEIVABLE_INQUIRY.대출정보`, { defaultValue: '대출정보' }) },
		{ id: 2, label: t(`LOAN_RECEIVABLE_INQUIRY.이자납부내역`, { defaultValue: '이자납부내역' }) },
		{ id: 3, label: t(`LOAN_RECEIVABLE_INQUIRY.변동내역`, { defaultValue: '변동내역' }) },
		{ id: 4, label: t(`LOAN_RECEIVABLE_INQUIRY.담보자산`, { defaultValue: '담보자산' }) },
		{ id: 5, label: t(`LOAN_RECEIVABLE_INQUIRY.연장내역`, { defaultValue: '연장내역' }) },
		{ id: 6, label: t(`LOAN_RECEIVABLE_INQUIRY.채무내역`, { defaultValue: '채무내역' }) },
		{ id: 7, label: t(`LOAN_RECEIVABLE_INQUIRY.상담내역`, { defaultValue: '상담내역' }) },
		{ id: 8, label: t(`LOAN_RECEIVABLE_INQUIRY.History`, { defaultValue: 'History' }) },
		{ id: 9, label: t(`LOAN_RECEIVABLE_INQUIRY.첨부파일`, { defaultValue: '첨부파일' }) },
	];

	// 각 탭이 활성화 되었을 때만 해당 화면에서 필요한 API를 통신하기 위해 isActive로 구분
	const DynamicComponent = ({ pillId, isActive }) => {
		const LazyComponent = Detail002Components[pillId];
	
		return (
			<Suspense>
				{LazyComponent && <LazyComponent customerInfo={customerInfo} isActive={isActive} />}
			</Suspense>
		);
	};

	return (
		<div className="col">
			<ul className="nav nav-pills mb-2 nav-fill">
				{navPills.map((pill) => (
					<li key={pill.id} className="nav-item">
						<a href={`#nav-pills-tab-${pill.id}`} 
							data-bs-toggle="tab" 
							className={`nav-link ${pill.id === activeTab ? 'active' : ''}`}
							style={pill.id === activeTab ? navStyle : {}}
							onClick={() => setActiveTab(pill.id)}
						>
							<span className="d-sm-none">{pill.label}</span>
							<span className="d-sm-block d-none">{pill.label}</span>
						</a>
					</li>
				))}
			</ul>

			<div className="tab-content rounded-top panel rounded-0 m-0">
				{navPills.map((pill) => (
					<div key={pill.id} className={`tab-pane fade ${pill.id === activeTab ? 'active show' : ''}`} id={`nav-pills-tab-${pill.id}`}>
						<DynamicComponent pillId={pill.id} isActive={pill.id === activeTab} />
					</div>
				))}
			</div>
		</div>
	);
};

export default Detail002;